import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SimpleFooterItem = ({ id, target, href, title, text }) => {
    const { t } = useTranslation();

    const isI18nKey = (key) => typeof key === 'string' && key?.startsWith("FOOTER.");

    const displayText = isI18nKey(text) ? t(text) : text;
    const displayTitle = isI18nKey(title) ? t(title) : title;

    return (
        <a
            className="footer__item"
            target={target}
            href={href}
            title={displayTitle}
            id={"linkFooter" + id}
        >
            {displayText.toUpperCase()}
        </a>
    );
};

SimpleFooterItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    target: PropTypes.string,
    href: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
};

SimpleFooterItem.defaultProps = {
    target: "",
    id: undefined,
    href: "",
    title: "",
    text: "",
};

export default SimpleFooterItem;
